import { CheckOutlined, CustomerServiceOutlined } from '@ant-design/icons';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import { Timeline } from 'antd';
import CrownIcon from 'assets/Icons/CrownIcon';
import KeyIcon from 'assets/Icons/KeyIcon';
import { motion } from 'framer-motion';
import moment from 'moment';
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { twMerge } from 'tailwind-merge';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';
import { ShouldRender } from '@/components/shared/basic/ShouldRender';
import { formateErrorObject } from '@/components/shared/formateErrorObject';
import { LoadingV2 } from '@/components/shared/LoadingV2';
import { notify } from '@/components/shared/notify';

import { user } from '@/atoms/user';
import { userConsumable } from '@/services/Subscribe';
import { hasPreviouslySubscribed, isSubscriptionActive } from '@/utils/index';
import { IUserConsumable, PlanNameEnum } from '@/utils/interfaces/Subscription';
import { User } from '@/utils/interfaces/User';

export const getSubPlanName = (name: string) => {
  if (name === PlanNameEnum.Standard || name === PlanNameEnum.Premium) {
    return 'ZebraLearn Prime';
  }
  if (name === PlanNameEnum.Plus) {
    return 'ZebraLearn Lite';
  }
  return name;
};
export const getSubPlanNameLog = (name: string) => {
  if (name === PlanNameEnum.Premium) {
    return 'ZebraLearn Prime Plus';
  }
  if (name === PlanNameEnum.Standard) {
    return 'ZebraLearn Prime';
  }
  if (name === PlanNameEnum.Plus) {
    return 'ZebraLearn Lite';
  }
  return name;
};

const GemsTransactions = () => {
  const router = useRouter();
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<IUserConsumable>();
  const userData: User | undefined = useRecoilValue(user);

  // const items = [
  //   {
  //     children: (
  //       <div className='mx-3 flex gap-3 items-start pb-6'>
  //         <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
  //           <KeyIcon height={16} />
  //           <p className='font-semibold text-white text-sm/5'>1</p>
  //         </div>
  //         <div>
  //           <p className='text-xs/5 font-semibold text-white'>Subscribed</p>
  //           <p className='text-grayZl-500 font-normal text-xs/5'>
  //             29 April, 2025
  //           </p>
  //         </div>
  //       </div>
  //     ),
  //     dot: (
  //       <button className='w-8 h-8 rounded-full bg-white flex items-center justify-center'>
  //         <CheckOutlined className='text-base text-black' />
  //       </button>
  //     ),
  //   },
  //   {
  //     children: (
  //       <div className='mx-3 flex gap-3 items-start pb-6'>
  //         <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
  //           <KeyIcon height={16} />
  //           <p className='font-semibold text-white text-sm/5'>1</p>
  //         </div>
  //         <div>
  //           <p className='text-xs/5 font-semibold text-white'>Initiated</p>
  //           <p className='text-grayZl-500 font-normal text-xs/5'>
  //             29 April, 2025
  //           </p>
  //         </div>
  //       </div>
  //     ),
  //     dot: (
  //       <button className='w-8 h-8 rounded-full bg-white flex items-center justify-center'>
  //         <CheckOutlined className='text-base text-black' />
  //       </button>
  //     ),
  //   },
  //   {
  //     children: (
  //       <div className='mx-3 flex gap-3 items-start pb-6'>
  //         <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
  //           <KeyIcon height={16} />
  //           <p className='font-semibold text-white text-sm/5'>1</p>
  //         </div>
  //         <p className='text-xs/5 font-normal  text-white '>
  //           <span className=''>Next Gem will available in </span>
  //           <span className='font-semibold'>29 Days</span>
  //         </p>
  //       </div>
  //     ),
  //     dot: (
  //       <button className='w-8 h-8 rounded-full bg-black border border-white border-dashed text-xs/5 font-medium  flex items-center justify-center text-white'>
  //         3
  //       </button>
  //     ),
  //   },
  //   {
  //     children: (
  //       <div className='mx-3 flex gap-3 items-start pb-6'>
  //         <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
  //           <KeyIcon height={16} className='grayscale ' />
  //           <p className='font-semibold text-white text-sm/5'>1</p>
  //         </div>
  //         <div className='text-xs/5 font-normal  text-grayZl-500'>
  //           <p className=''>Unlocking on 29 July, 2025</p>
  //         </div>
  //       </div>
  //     ),
  //     dot: (
  //       <button className='w-8 h-8 rounded-full bg-black border border-grayZl-850 text-xs/5 font-medium  flex items-center justify-center text-white'>
  //         4
  //       </button>
  //     ),
  //   },
  //   {
  //     children: (
  //       <div className='mx-3 flex gap-3 items-start pb-6'>
  //         <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
  //           <KeyIcon height={16} className='grayscale ' />
  //           <p className='font-semibold text-white text-sm/5'>1</p>
  //         </div>
  //         <div className='text-xs/5 font-normal  text-grayZl-500'>
  //           <p className=''>Unlocking on 29 July, 2025</p>
  //         </div>
  //       </div>
  //     ),
  //     dot: (
  //       <button className='w-8 h-8 rounded-full bg-black border border-grayZl-850 text-xs/5 font-medium  flex items-center justify-center text-white'>
  //         5
  //       </button>
  //     ),
  //   },
  //   {
  //     children: (
  //       <div className='mx-3 flex gap-3 items-start pb-6'>
  //         <div className='text-xs/5 text-white font-normal flex gap-1'>
  //           <p>Subscription renews in</p>
  //           <p className='font-semibold'>265 Days</p>

  //         </div>
  //       </div>
  //     ),
  //     dot: (
  //       <button className='w-8 h-8 rounded-full bg-black border border-grayZl-850 text-xs/5 font-medium  flex items-center justify-center text-white'>
  //         <CrownIcon height={16} />
  //       </button>
  //     ),
  //   },
  // ];

  const transactions = data?.feature_consumables_list[0]?.map((i, index) => {
    const unloadDate = new Date(i?.unload_at);
    const usedDate = i?.used_at ? new Date(i?.used_at) : null;

    // 🟢 CASE 1: Claimed early (used before unlock)
    if (usedDate && usedDate < unloadDate) {
      return {
        key: `transaction-${i?.id || index}`,
        children: (
          <div className='mx-3 flex gap-3 items-start pb-6'>
            <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
              <KeyIcon height={16} className='text-purple-300' />
              <p className='font-semibold text-white text-sm/5'>1</p>
            </div>
            <div>
              <p className='text-xs/5 font-normal  text-grayZl-500'>
                Gem adjusted from your initial order before applying any
                discounts.
              </p>
            </div>
          </div>
        ),
        dot: (
          <button className='w-8 h-8 rounded-full bg-white flex items-center justify-center'>
            <CheckOutlined className='text-base text-black' />
          </button>
        ),
      };
    }

    if (new Date() >= new Date(i?.unload_at)) {
      return {
        key: `transaction-${i?.id || index}`,
        children: (
          <div className='mx-3 flex gap-3 items-start pb-6'>
            <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
              <KeyIcon height={16} />
              <p className='font-semibold text-white text-sm/5'>1</p>
            </div>
            <div>
              <p className='text-xs/5 font-semibold text-white'>Gem Granted</p>
              <p className='text-grayZl-500 font-normal text-xs/5'>
                {moment(i.unload_at).format('DD MMMM, YYYY')}
              </p>
            </div>
          </div>
        ),
        dot: (
          <button className='w-8 h-8 rounded-full bg-white flex items-center justify-center'>
            <CheckOutlined className='text-base text-black' />
          </button>
        ),
      };
    }

    return {
      children: (
        <div className='mx-3 flex gap-3 items-start pb-6'>
          <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
            <KeyIcon height={16} className='grayscale ' />
            <p className='font-semibold text-white text-sm/5'>1</p>
          </div>
          <div className='text-xs/5 font-normal  text-grayZl-500'>
            <p className=''>
              Unlocking on {moment(i.unload_at).format('DD MMMM, YYYY')}
            </p>
          </div>
        </div>
      ),
      dot: (
        <button className='w-8 h-8 rounded-full bg-black border border-grayZl-850 text-xs/5 font-medium  flex items-center justify-center text-white'>
          {index + 1}
        </button>
      ),
    };
  });

  transactions?.unshift({
    key: 'plan-start',
    children: (
      <div className='mx-3 flex gap-3 items-start pb-6'>
        {/* <div className='pl-1 pr-2 py-0.5 gap-0.5 flex items-center rounded bg-grayZl-900'>
          <KeyIcon height={16} />
          <p className='font-semibold text-white text-sm/5'>1</p>
        </div> */}
        <div>
          <p className='text-xs/5 font-semibold text-white'>Plan Subscribed</p>
          <p className='text-grayZl-500 font-normal text-xs/5'>
            {moment(data?.active_sub.created_at).format('DD MMMM, YYYY')}
          </p>
        </div>
      </div>
    ),
    dot: (
      <button className='w-8 h-8 rounded-full bg-primary flex items-center justify-center'>
        <CheckOutlined className='text-base text-white' />
      </button>
    ),
  });

  transactions?.push({
    key: 'plan-end',
    children: (
      <div className='mx-3 flex gap-3 items-start'>
        <div className='text-xs/5 text-white font-normal flex gap-1'>
          {moment(data?.active_sub?.expired_at).diff(moment(), 'days') < 0 ? (
            <p className='font-normal text-white font-xs'>
              {' '}
              {`Subscription renews on ${moment(data?.active_sub?.expired_at).format('D MMMM, YYYY')}`}
            </p>
          ) : (
            <>
              <p>Subscription ends in</p>
              <p className='font-semibold'>
                {`${moment(data?.active_sub?.expired_at).diff(moment(), 'days')} Days`}
              </p>
            </>
          )}
        </div>
      </div>
    ),
    dot: (
      <button className='w-8 h-8 rounded-full bg-black border border-grayZl-850 text-xs/5 font-medium  flex items-center justify-center text-white'>
        <CrownIcon height={16} />
      </button>
    ),
  });
  const inviteFriends = (
    <div className='flex items-center gap-5 p-6 bg-grayZl-950 rounded-lg mb-4 justify-between'>
      <div className='flex flex-col gap-2'>
        <p className='text-base/6 font-semibold text-white'>
          Invite Your Friends
        </p>
        <p className='text-xs/5 text-grayZl-500 font-normal'>
          Help them save extra 30% with subscription
        </p>
      </div>
      <ButtonDefault
        onClick={() => router.push('/refer-earn')}
        size={0}
        variant={ButtonVariants.UNSTYLED}
        className='px-[22px] py-[9px] text-xs/5 font-semibold text-white bg-grayZl-900'
      >
        Invite
      </ButtonDefault>
    </div>
  );

  const contactUs = (
    <button
      onClick={() => router.push('/contact')}
      className='p-3 rounded-lg border border-grayZl-900 flex gap-2 items-center w-full'
    >
      <CustomerServiceOutlined className='w-6 h-6 text-grayZl-600 text-2xl' />
      <p className='text-white text-xs/5 font-bold flex-1 text-left'>
        Contact Support
      </p>
      <ChevronRightIcon className='w-6 h-6 ' />
    </button>
  );

  const userConsumableHandle = async () => {
    try {
      setLoading(true);
      const result = await userConsumable();
      setData(result.data);
    } catch (error: any) {
      console.error(error);
      notify(formateErrorObject(error), 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    userConsumableHandle();
  }, []);

  const physical =
    data?.features?.[0]?.periodicity &&
    data?.active_sub?.plan?.rules?.[0]?.physical;

  const digital =
    data?.features?.[0]?.periodicity &&
    data?.active_sub?.plan?.rules?.[0]?.digital;

  const bookPerMonth = data?.features?.[0]?.periodicity
    ? data?.features?.[0]?.quota * data?.active_sub?.plan?.periodicity
    : null;

  if (loading) {
    return (
      <LoadingV2
        loaderColor='white'
        messages={[
          'Almost there, thanks for your patience!',
          'Getting everything set up for you.',
          'Your content is on its way!',
          "Just a sec, making sure everything's perfect.",
          "Hold on, we're almost ready!",
          "Loading... we'll be with you shortly.",
          "Thanks for waiting, we're preparing your journey!",
        ]}
      />
    );
  }

  return (
    <motion.div
      className='lg:gap-16 md:gap-7 gap-16 md:flex mx-auto md:max-w-screen-md lg:max-w-screen-lg xl:max-w-7xl md:mt-3 mt-3 md:px-3 px-0'
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className='md:flex-1'
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        <motion.div
          className='md:rounded-xl rounded-b-xl overflow-hidden mb-6'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <div className='py-[11px] px-2 bg-grayZl-950 md:hidden'>
            <ChevronLeftIcon className='w-[20px] h-[20px]' />
          </div>
          <div className='flex gap-3 items-end md:p-6 p-4 bg-grayZl-950'>
            <div className='flex flex-col gap-2 flex-1'>
              <CrownIcon />
              <p className='text-white text-2xl font-semibold capitalize'>
                {data?.active_sub?.plan?.name
                  ? getSubPlanName(data?.active_sub?.plan?.name) + ' Plan'
                  : null}
              </p>
              <p className='text-grayZl-500 text-xs/5 font-normal'>
                {physical ? bookPerMonth + ' Hardcover Books' : null}
                {physical && digital ? ' + ' : null}
                {digital
                  ? bookPerMonth + ` ${physical ? 'Free ' : ''}Digital Books`
                  : null}
              </p>
            </div>
            <ShouldRender check={isSubscriptionActive(userData)}>
              <div>
                <ButtonDefault
                  onClick={() => router.push('/subscription')}
                  size={0}
                  variant={ButtonVariants.UNSTYLED}
                  className='px-3 py-1.5 text-xs/5 font-semibold text-white bg-grayZl-900'
                >
                  Change Plan
                </ButtonDefault>
              </div>
            </ShouldRender>
          </div>
          <div className='px-4 bg-cartBgColor'>
            <p className='text-xs/5 font-medium text-grayZl-600 text-center py-1'>
              {data?.active_sub?.expired_at
                ? moment(data?.active_sub?.expired_at).diff(moment(), 'days') <
                  0
                  ? 'Plan Expired'
                  : `Expires in ${moment(data?.active_sub?.expired_at).diff(moment(), 'days')} Days`
                : null}
            </p>
          </div>
        </motion.div>

        <motion.div
          className='flex items-center gap-2.5 md:mb-6 mb-5 md:px-0 px-4'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <div className='flex-1 border border-dropDownMenuBg rounded-lg flex flex-col items-center gap-2 px-4 pt-3 pb-4'>
            <p className='text-center text-xs/5 font-normal text-grayZl-500'>
              Gems Available
            </p>
            <div className='flex items-center gap-1'>
              <KeyIcon className='w-[26px] h-[26px]' />
              <p className='text-2xl/8 font-semibold text-white'>
                {data?.features?.[0]?.available_quantity || '0'}
              </p>
            </div>
          </div>
          <div className='flex-1 border border-dropDownMenuBg rounded-lg flex flex-col items-center gap-2 px-4 pt-3 pb-4'>
            <p className='text-nowrap text-center text-xs/5 font-normal text-grayZl-500'>
              Gems Used / Total Gems
            </p>
            <div className='flex items-center gap-1'>
              <KeyIcon className='w-[26px] h-[26px]' />
              <p className='text-2xl/8 font-semibold text-white'>
                {data?.features?.[0]?.used_quantity + ' '}/
                {' ' + data?.features?.[0]?.total_quantity}
              </p>
            </div>
          </div>
        </motion.div>
        <motion.div
          className='md:mb-16 mb-5 md:px-0 px-4'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <ShouldRender
            check={
              isSubscriptionActive(userData) &&
              data?.features?.[0]?.available_quantity
            }
          >
            <ButtonDefault
              onClick={() => router.push('/books')}
              size={0}
              variant={ButtonVariants.PRIMARY}
              className='py-[9px] px-6 rounded-lg text-sm leading-[22px] font-semibold w-full'
            >
              Claim Books
            </ButtonDefault>
          </ShouldRender>
          <ShouldRender
            check={
              !isSubscriptionActive(userData) &&
              hasPreviouslySubscribed(userData)
            }
          >
            <ButtonDefault
              onClick={() => router.push('/subscription')}
              size={0}
              variant={ButtonVariants.PRIMARY}
              className='py-[9px] px-6 rounded-lg text-sm leading-[22px] font-semibold w-full'
            >
              Subscribe
            </ButtonDefault>
          </ShouldRender>
        </motion.div>
        <motion.div
          className='md:hidden mb-3 block px-4'
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <p className=' text-base/6 text-white font-semibold'>
            Transaction Information
          </p>
        </motion.div>

        {React.cloneElement(inviteFriends, {
          className: twMerge(inviteFriends.props.className, 'md:flex hidden'),
        })}
        {React.cloneElement(contactUs, {
          className: twMerge(contactUs.props.className, 'md:flex hidden'),
        })}
      </motion.div>

      <motion.div
        className='md:flex-1'
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        <div className='md:border border-0 border-grayZl-850 rounded-xl md:p-6 p-4 md:mb-0'>
          <p className='md:block hidden text-base/6 text-white font-semibold mb-8'>
            Transaction Information
          </p>
          <div>
            <Timeline rootClassName='m-4' items={transactions} />
          </div>
        </div>
      </motion.div>

      {React.cloneElement(inviteFriends, {
        className: twMerge(
          inviteFriends.props.className,
          'md:hidden flex rounded-none px-4 py-5',
        ),
      })}
      <div className='md:hidden flex mx-4'>
        {React.cloneElement(contactUs, {
          className: twMerge(contactUs.props.className, 'md:hidden flex'),
        })}
      </div>
    </motion.div>
  );
};

export default GemsTransactions;
